import angular from 'angular';
import { IProcessoAvaliadorListResponse } from '../../models/processo-avaliador.model';

export class ConfigurarLoteModalService {
    static $inject = [
        '$uibModal'
    ];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) { }

    public open(processoPadrao: IProcessoAvaliadorListResponse | null): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./configurarlote.modal.html'),
            controller: 'ConfigurarLoteModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                defaultProcesso: () => processoPadrao ? angular.copy(processoPadrao) : null
            }
        });
    }
}
